/* eslint-disable */
import React from "react";
import last_new_asset from "../../assets/01_Home/Banner_Image.webp";
import read_more_icon from "../../assets/hyundai-icono-ver-mas.svg";
import { Link } from "react-router-dom";
import { getResponsiveImage } from "../../utils/imageHelper";


interface LastNewsComponentProps {
  lastNewsData: any;
  category: any;
}

const LastNewsComponent: React.FC<LastNewsComponentProps> = ({
  lastNewsData,
  category,
}) => {
  // Verifica que lastNewsData y Categories existan antes de procesar
  const posts =
    lastNewsData?.Categories?.flatMap((item: any) =>
      item.posts.map((post: any) => ({
        ...post,
        category: item.category, // Accedemos a la categoría del padre
        category_id: item.category_id, // Accedemos al category_id del padre
      }))
    ) || [];

  // Asegúrate de que los posts no estén vacíos y ordénalos por fecha
  if (posts.length > 0) {
    posts.sort(
      (a: any, b: any) =>
        new Date(b.creation_datetime).getTime() -
        new Date(a.creation_datetime).getTime()
    );
  }

  // Obtenemos los 2 posts más recientes
  const twoMostRecentPosts = posts.slice(0, 2);

  // Concatenamos la categoría y el category_id de cada post
  const postsWithCategoryInfo = twoMostRecentPosts.map((post: any) => ({
    ...post,
    categoryInfo: `${post.category} - ${post.category_id}`, // Concatenamos la categoría y el category_id
  }));

  // Si no hay posts, evita errores
  const firstPost = postsWithCategoryInfo[0] || {};
  const secondPost = postsWithCategoryInfo[1] || {};

  /* console.log(secondPost); */


  return (
    <>
      {/* H1 - Título principal de la página de noticias */}
      <h1 className="title-last-news-component">Últimas noticias</h1>
      
      <div className="container-last-news-component">
        {/* Primer post */}
        <div className="left-container-last-news-component" style={{ position: "relative", overflow: "hidden" }}>
          <img
            src={getResponsiveImage(firstPost?.media?.url || '').desktop}
            alt={firstPost?.title || "Noticia Hyundai"}
            loading="lazy"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 0,
              pointerEvents: "none"
            }}
          />
          <div className="internal-container-last-news-component" style={{ position: "relative", zIndex: 1 }}>
            {/* H2 - Título de la noticia principal */}
            <h2 className="description">{firstPost?.title}</h2>
            
            {/* H3 - Categoría de la noticia */}
            <h3 className="subtitle">{firstPost?.category}</h3>
            
            <Link
              className="readMore"
              to={`/noticias/${firstPost?.category_id}/${firstPost?.slug}`}
            >
              <span className="txtt">Leer más</span>
              <img loading="lazy" src={read_more_icon} className="iconn" alt="Leer mas" />
            </Link>
          </div>
        </div>

        {/* Segundo post (Con imagen predeterminada si no existe el segundo post) */}
        <div className="right-container-last-news-component" style={{ position: "relative", overflow: "hidden" }}>
          <img
            src={getResponsiveImage(secondPost?.media?.url || '').desktop}
            alt={secondPost?.title || "Noticia Hyundai"}
            loading="lazy"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              zIndex: 0,
              pointerEvents: "none"
            }}
          />
          <div className="internal-container-last-news-component" style={{ position: "relative", zIndex: 1 }}>
            {/* H2 - Título de la noticia secundaria */}
            <h2 className="description">
              {secondPost?.title ||
                "Hyundai se asociará con entidades gubernamentales para proteger los ecosistemas de carbono azul"}
            </h2>
            
            {/* H3 - Categoría de la noticia */}
            <h3 className="subtitle">
              {secondPost?.category || "Categoría de contenido"}
            </h3>
            
            <Link
              className="readMore"
              to={`/noticias/${secondPost?.category_id}/${secondPost?.slug}`}
            >
              <span className="txtt">Leer más</span>
              <img loading="lazy" src={read_more_icon} className="iconn" alt="leer mas" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default LastNewsComponent;